import environment from '../config/environment';
import getUrlPath from './getUrlPath';
import logger from './logger';
import { getContract, getOrderContracts } from '../apis/order';
import { GOOGLE_MAP_BASE_URL } from '../constants/locations';
import { messageContents } from '../constants/message';
import { NavigateType } from '../types/route';
import { openMessageModal } from './message';
import { ShowActiveRentalItem } from '../types/order';
import { SignupUrlKeys } from '../types/signup/common';
import { url } from '../constants/url';
import { UrlDetails } from '../types/url';

export const redirectToCart = () => {
  window.location.href = `${environment.WEBFLOW_BASE_PATH}/cart`;
};

export const openGoogleMapPage = (link: string) => {
  window.open(link, '_blank');
};

export const getDirectionsLinkFromLatLong = (
  latitude: string | number | undefined,
  longitude: string | number | undefined,
) => {
  if (!latitude || !longitude) {
    return;
  }
  return `${GOOGLE_MAP_BASE_URL}?q=${latitude},${longitude}`;
};

export const redirectToCategories = () => {
  window.location.href = `${environment.WEBFLOW_BASE_PATH}`;
};

export const equipmentClassLink = (slug: string) => {
  return `${environment.WEBFLOW_BASE_PATH}/equipment-classes/${slug}`;
};

export const redirectToEquipmentClass = (slug: string) => {
  window.location.href = `${environment.WEBFLOW_BASE_PATH}/equipment-classes/${slug}`;
};

export const redirectToCategoryPage = (slug: string) => {
  window.location.href = `${environment.WEBFLOW_BASE_PATH}/categories/${slug}`;
};

export const redirectToTextSearchResultsPage = (query: string) => {
  window.location.href = `/search?query=${encodeURIComponent(query)}`;
};

export const redirectToAssetPage = (assetId: number) => {
  window.open(`${environment.FLEET_APP_URL}/#/assets/all/asset/${assetId}/history`, '_blank');
};

export const redirectToOrdersPage = () => {
  const orderPath = getUrlPath(url.account.subPath.orders.id);
  if (orderPath) window.location.href = orderPath;
};

export const redirectToSignUp = (redirectPath: string | null) => {
  const cartPath = getUrlPath(url.rental.subPath.cart.id);
  const checkoutPath = getUrlPath(url.rental.subPath.checkout.id);
  const dashboardPath = getUrlPath(url.account.id);
  const redirectUrl =
    redirectPath === cartPath || redirectPath === checkoutPath ? redirectPath : dashboardPath;
  window.location.href = `/signup?${SignupUrlKeys.REDIRECT_URL}=${encodeURIComponent(
    redirectUrl || '',
  )}`;
};

export const redirectToHome = () => {
  window.location.href = `/`;
};

export const redirect = (url: UrlDetails, navigateType?: NavigateType, params?: string) => {
  let link: string | undefined = getUrlPath(url.id);
  if (!link) {
    logger('error', 'link not found');
    return;
  }
  if (params) {
    link += params;
  }
  if (navigateType === NavigateType.OPEN_IN_NEW_TAB) {
    window.open(link, '_blank');
  } else if (link) {
    window.location.href = link;
  }
};

export const redirectToDashboard = () => {
  const dashboardPath = getUrlPath(url.account.id);
  if (dashboardPath) {
    window.location.href = dashboardPath;
  }
};

export const redirectToRentalPdf = async (rental: ShowActiveRentalItem) => {
  try {
    if (rental.rentalId) {
      const contract = await getOrderContracts(rental.orderId);
      const response = await getContract(contract.contract_id, 'pdf');

      window.open(
        window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' })),
        '_blank',
      );
    }
  } catch (error) {
    console.error('error in fetching rental details: ', error);
    openMessageModal(messageContents.rentalPdfError);
  }
};
